import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {Link} from 'gatsby';

function Solution(props) {
    return (
        <div className="services_solution  p-100">
            <Container>
                <Row>
                    <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
                        <div className="example" data-text="Consultancy">
                            <h2>Partner With A Digital Strategy Consultancy</h2>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="offset-lg-1">
                        <p>TekRevol’s digital strategy consultancy is crafted delicately for startups and small
                            businesses to adopt the modern digital revolution and build their reputation with freshly
                            laid out foundations. Pivot your movements and direction to a new level, correct the course
                            and signify value deliverance.</p>
                        <p>Our efficient digital strategies speak for themselves. We eye and work for utmost servicing,
                            providing unmatched strategic solutions to amplify the outcomes, increase productivity and
                            yield maximum traction. Our plans deliver across multiple channels and ensure promise
                            fulfillment throughout.</p>
                         <Link to="/contact"
                              className="border_btn" aria-label="TekRevol Contact">Let's Connect!</Link>
                    </Col>

                </Row>
            </Container>
        </div>
    );
}

export default Solution;